import axios from "@/libs/api.request";
// 获取列表
export const getList = (data) => {
  return axios.request({
    url: "/shipments/ffc_shipment/list",
    data,
    method: "post",
  });
};

// 退回
export const returnFun = (data) => {
  return axios.request({
    url: "/shipments/ffc_shipment/addFFCReturn",
    data,
    method: "post",
  });
};
